import { useRef, useState } from "react";
import { X } from "lucide-react";
import { ActionIcon } from "./ActionIcon";
import { Input } from "./Input";

type ChipInputProps = {
  disabled?: boolean;
  label: string;
  onValueChange: (values: string[]) => void;
  placeholder?: string;
  values: string[];
};

export function ChipInput({
  disabled = false,
  label,
  onValueChange,
  placeholder,
  values,
}: ChipInputProps) {
  const [input, setInput] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);

  function commit() {
    const value = input.trim();
    const alreadyExists = values.some(
      (item) => item.toLowerCase() === value.toLowerCase(),
    );

    if (value && !alreadyExists) {
      onValueChange([...values, value]);
    }
    setInput("");
  }

  return (
    <div
      className="ui-chip-input"
      data-disabled={disabled}
      onClick={(event) => {
        if (!(event.target as HTMLElement).closest("button")) {
          inputRef.current?.focus();
        }
      }}
    >
      {values.map((value) => (
        <span className="ui-chip-input-item" key={value}>
          {value}
          {!disabled && (
            <ActionIcon
              color="accent"
              icon={<X />}
              label={`Remove ${value}`}
              onClick={() =>
                onValueChange(values.filter((item) => item !== value))
              }
              size="compact"
            />
          )}
        </span>
      ))}
      <Input
        aria-label={label}
        disabled={disabled}
        onBlur={commit}
        onChange={(event) => setInput(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            event.preventDefault();
            commit();
          }
        }}
        placeholder={values.length ? "" : placeholder}
        ref={inputRef}
        value={input}
      />
    </div>
  );
}
